import React from "react";

export class ResponsibleDisclosureEN extends React.Component {
    render() {
        return (
            <>
                <p>
                    Last update: <b>29/03/2024</b>
                    <br />
                    <br />
                </p>

                <p>DH Healthcare GmbH considers it important that its information and systems are secure.</p>

                <p>Despite our concern for the security of these systems, it may occur that there is still a vulnerability.</p>

                <p>
                    If you have found a vulnerability in one of our systems, please let us know so that we can take measures as quickly as possible. We would like to work with you
                    to protect our data, our users and our systems in a better way.
                </p>

                <p>
                    We have therefore opted for a policy of coordinated disclosure of vulnerabilities (also known as the ‘Responsible Disclosure Policy’) so that you can inform us
                    when you discover a vulnerability.
                </p>

                <p>This Responsible Disclosure Policy applies to the following systems, maintained by DH Healthcare GmbH:</p>
                <ul>
                    <li>
                        <a href="https://www.dedalus.com/be/en/our-offer/products/pacsonweb/" target="_blank" rel="noreferrer">
                            www.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://secure.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://secure.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://france.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://france.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://norway.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://norway.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swiss.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swiss.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://germany.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://germany.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://latem.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://latem.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://brazil.imaging.dedalus.com" target="_blank" rel="noreferrer">
                            https://brazil.imaging.dedalus.com
                        </a>
                    </li>
                    <li>
                        <a href="https://austria.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://austria.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://swisscom.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://swisscom.pacsonweb.com
                        </a>
                    </li>
                    <li>
                        <a href="https://labs.pacsonweb.com" target="_blank" rel="noreferrer">
                            https://labs.pacsonweb.com
                        </a>
                    </li>

                    <li>
                        <a href="https://secure.risonweb.com" target="_blank" rel="noreferrer">
                            https://secure.risonweb.com
                        </a>
                    </li>
                </ul>

                <p>
                    In any case of doubt, please contact us to clarify matters via <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>

                <h2>What we ask of you</h2>

                <p>If you discover a vulnerability in one of our systems, we ask you to:</p>

                <ul>
                    <li>
                        Report the vulnerability as soon as possible after discovery. Mail your findings to{" "}
                        <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>.
                    </li>
                    <li>
                        Provide sufficient information to reproduce the vulnerability so that we can solve the problem as quickly as possible. Usually the URL of the affected
                        system and a description of the vulnerability is sufficient, but for more complex vulnerabilities more may be needed.
                    </li>
                    <li>
                        Leave your contact details, so that DH Healthcare GmbH can contact you to work together for a safe result. Leave at least your name, e-mail address and/or
                        telephone number. Reporting under a pseudonym is possible, but make sure that we can contact you if we should have additional questions.
                    </li>
                    <li>Confirm that you have acted and will continue to act in accordance with this Responsible Disclosure Policy.</li>
                </ul>

                <h2>Rules you must follow</h2>

                <ul>
                    <li>Don’t disclose the vulnerability until we have been able to correct it. See below for possible publication</li>
                    <li>
                        Don’t exploit the vulnerability by unnecessarily copying, deleting, adapting or viewing data. Or, for example, by downloading more data than is necessary to
                        demonstrate the vulnerability.
                    </li>
                    <li>
                        Don't apply the following actions:
                        <ul>
                            <li>Placing malware (virus, worm, Trojan horse, etc.).</li>
                            <li>Copying, modifying or deleting data in a system.</li>
                            <li>Making changes to the system.</li>
                            <li>Repeatedly accessing the system or sharing access with others.</li>
                            <li>Using automated scanning tools.</li>
                            <li>Using the so-called "brute force" of access to systems.</li>
                            <li>Using denial-of-service or social engineering (phishing, vishing, spam,...).</li>
                        </ul>
                    </li>
                    <li>Immediately erase all data obtained through vulnerability as soon as it has been reported to DH Healthcare GmbH.</li>
                    <li>
                        Don’t perform actions that could have an impact on the proper functioning of the system, both in terms of availability and performance, but also in terms of
                        confidentiality and integrity of the data.
                    </li>
                </ul>

                <p>
                    Acts under this Responsible Disclosure Policy should be limited to conducting tests to identify potential vulnerabilities, and sharing this information with DH
                    Healthcare GmbH.
                </p>
                <p>
                    If, after the vulnerability has been removed, you wish to publish information about the vulnerability, we ask you to notify us at least one month before
                    publication, and to give us the opportunity to respond. Identifying us in a publication is only possible after we have given our explicit approval.
                </p>

                <h2>What we promise</h2>

                <p>If you have complied with the above terms of the Responsible Disclosure Policy and have not committed any other breaches,</p>
                <ul>
                    <li>we will not take any legal action against you.</li>
                    <li>
                        we will respond to your report within a short period of time, if possible within 10 working days, with our review of the report and any expected date for
                        resolution.
                    </li>
                    <li>
                        we will treat your report confidentially and will not share your personal data with third parties without your consent unless this is necessary to comply
                        with a legal obligation.
                    </li>
                    <li>we will keep you informed of the progress of solving the problem.</li>
                    <li>
                        we want to thank you for reporting a security problem that is not yet known to us by offering the opportunity to be listed in our{" "}
                        <a href="/POW3/HallOfFame">"Hall Of Fame"</a>.
                    </li>
                    <li>we strive to solve all problems within a short period of time.</li>
                </ul>

                <p>We may however choose to ignore low quality reports.</p>
                <p>
                    If you have any questions, we encourage you to address them to <a href="mailto:security.disclosure@dedalus.com">security.disclosure@dedalus.com</a>
                </p>
                <p>In case of doubt about the applicability of this policy, please contact us first via this e-mail address, to ask for explicit permission.</p>
                <p>We reserve the right to change the content of this Policy at any time, or to terminate the Policy.</p>
                <p>This text is a derivative work of "Responsible Disclosure" by Floor Terra, used under a Creative Commons Attribution license 3.0.</p>
            </>
        );
    }
}
